import React, { useState, useEffect } from 'react';
import CustomDialog from '../../../shared/components/CustomDialog';
import Button from '../../../shared/components/Button';
import CustomSelect from '../../../shared/components/CustomSelect/CustomSelect';
import styles from '../../pages/GpsDetails/modalChangeSim.module.scss';

const ModalResetDevice = ({
  open,
  onClose,
  device,
  getDevicesSubstatusesRequest,
  substatuses,
  fetchingSubstatuses,
  patchDevicesRequest,
  getDevicesRequest,
  setDeviceSelected,
  imei
}) => {
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      getDevicesSubstatusesRequest({ codeStatus: 'bodega' });
      setSelectedWarehouse(null);
      setError(null);
    }
  }, [open, getDevicesSubstatusesRequest]);

  useEffect(() => {
    console.log(substatuses);
    if (substatuses && Array.isArray(substatuses)) {
      const options = substatuses.map(substatus => ({
        value: substatus._id,
        label: substatus.name,
        referenceModel: substatus.referenceModel,
        referenceId: substatus.referenceId
      }));
      setWarehouseOptions(options);
    }
  }, [substatuses]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedWarehouse) return;

    setIsSubmitting(true);
    setError(null);

    try {
      const updatePayload = {
        imeis: [device?.imei],
        data: {
          status: 'bodega',
          substatus: {
            referenceModel: selectedWarehouse.referenceModel,
            referenceId: selectedWarehouse.value
          }
        }
      };

      await patchDevicesRequest(updatePayload);

      setTimeout(() => {
        getDevicesRequest({
          imei: device?.imei,
          full_status: 1,
          limit: 50,
          page: 1
        });
      }, 700);

      onClose();
    } catch (err) {
      setError('Hubo un error al resetear el dispositivo.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const isValid = selectedWarehouse !== null;

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      dialogTitle="Resetear Dispositivo"
      className={styles.modal}
      dialogActions={
        <div className={styles.actions}>
          <div className={styles.cancelButton}>
            <Button onClick={onClose}>Cancelar</Button>
          </div>
          <Button
            className={styles.saveButton}
            onClick={handleSubmit}
            disabled={!isValid || isSubmitting || fetchingSubstatuses}
          >
            {isSubmitting ? 'Guardando...' : 'Guardar'}
          </Button>
        </div>
      }
    >
      <form className={styles.content}>
        <div className={styles.newCardSection}>
          <p style={{ marginBottom: '2px', fontSize: '14px'}}>
            Estás a punto de resetear este dispositivo. 
          </p>
          <p style={{ marginBottom: '30px', fontSize: '14px'}}>
           Elige la bodega a la que quieres enviarlo:
          </p>

          <div className={styles.formGroup}>
            <CustomSelect
              options={warehouseOptions}
              value={selectedWarehouse}
              onChange={setSelectedWarehouse}
              placeholder="Selecciona una bodega"
              isDisabled={fetchingSubstatuses}
              loading={fetchingSubstatuses}
              className={styles.selectWarehouse}
            />
          </div>
   
          {error && <div className={styles.errorText}>{error}</div>}
        </div>
      </form>
    </CustomDialog>
  );
};

export default ModalResetDevice;